import React, { useRef } from 'react';
import Slider from "react-slick";
import bannerDimension from '../../../assets/img/dimensionBanner.png';
import ErrorModal from '../../../components/Modal/ErrorModal';
import { Query } from "react-apollo";
import { addToDataLayerGTM } from '../../../utils/addToDataLayerGTM';
import { SkeletonBanner } from '../../../components/Skeleton';

import {
  dam_client,
  analytics_client,
  GET_DAM,
  ANALYTICS_INSERT_BANNER_CLICK,
} from '../apollo';


const settings_banner = {
  autoplaySpeed: 5000,
  autoplay: true,
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};

const BannerSlide = () => {
  const imgref = useRef(null);
  return (
    <div className="banner">
      <Query
        client={dam_client}
        variables={{ module_name: "Banner" }}
        query={GET_DAM}
      >
        {({ loading, error, data }) => {
          if (error) {
            // Google Tag Manager
            addToDataLayerGTM({
              'event': 'erro',
              'descricao': 'erro ao buscar coleção de assets'
            });
            return <ErrorModal />;
          };

          if (!loading && !data.assets_collections) {
            return (<div>(Vazio)</div>);
          }
          return (
            <Slider {...settings_banner}>
              {loading
                ? <SkeletonBanner>
                  <img ref={imgref} src={bannerDimension} />
                </SkeletonBanner>
                : data.assets_collections.assets.map((item, i) => (
                  <div key={item.id}>
                    <a
                      data-gtm-type="click"
                      data-gtm-clicktype="banner"
                      data-gtm-name={item.title}
                      data-gtm-banner-index={i}
                      onClick={
                        // Registra que o usuário clicou no banner
                        () => analytics_client.mutate({
                          variables: { banner_id: item.id, banner_title: item.title },
                          mutation: ANALYTICS_INSERT_BANNER_CLICK
                        })
                      } href={item.directlink} target="_blank">
                      <img
                        src={"https://portoseguro.sambalms.com.br/dam/assets/" + item.asset}
                        />
                    </a>
                  </div>
                ))}
            </Slider>
          )
        }}
      </Query>
    </div>
  );
}

export default BannerSlide;



// WEBPACK FOOTER //
// ./src/views/Home/components/BannerSlide.jsx